import { FC } from 'react';
import { SandpackFiles } from '@codesandbox/sandpack-react';
import { IEntityContentField } from '../../../lib/interfaces/Common';
import SandPackWrapper from './CodeSandpack';

type CodeBlockType = {
	field: IEntityContentField;
};

type FileItem = {
	name: string;
	code: string;
	hidden: boolean;
};

const CodeSandPackAdapter: FC<CodeBlockType> = ({ field }) => {
	const content: { [key: string]: FileItem } = field.content
		? JSON.parse(field.content)
		: null;
	const files: SandpackFiles = {};
	Object.values(content).forEach((value: FileItem) => {
		files[value.name] = { code: value.code, hidden: value.hidden };
	});
	return <SandPackWrapper files={files} field={field} />;
};

export default CodeSandPackAdapter;
